module.exports = __webpack_public_path__ + "img/2.318b6e8f.png";